export enum UserRole {
  ADMIN = '1',
  USER = '2'
}

export const MappingApiRoute = {
  [UserRole.ADMIN]: 'admin',
  [UserRole.USER]: 'user'
};
